import _jsx from "@babel/runtime/helpers/jsx";
var _Fragment, _Glyphicon;
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Button, Glyphicon, Text } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import clsx from 'clsx';

/**
 *  The OneClickButton component contains the button to send email to dealers within One-Click experience
 */
function OneClickButton(_ref) {
  let {
    handleEditSettingsClick = () => {},
    handleEmailSendClick = () => {},
    hideModifySettings = false,
    listingId,
    isFullSize,
    isModifySettingsIcon = true,
    oneClickEmailSent = false,
    wrapperClassNames = ''
  } = _ref;
  const handleEditSettings = useCallback(event => {
    handleEditSettingsClick(event);
    sendClick('oneClickButtonClick', event, {
      listingId,
      element: 'cta',
      content: 'edit'
    });
  }, [handleEditSettingsClick, listingId]);
  const buttonsize = isFullSize ? '' : 'small';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("div", {
    className: wrapperClassNames
  }, void 0, /*#__PURE__*/_jsx(Button, {
    block: true,
    bsSize: buttonsize,
    bsStyle: isModifySettingsIcon ? 'default' : 'primary',
    className: "display-flex justify-content-center align-items-center",
    "data-cmp": "btn-oneClick",
    onClick: handleEmailSendClick,
    disabled: oneClickEmailSent && !isModifySettingsIcon
  }, void 0, oneClickEmailSent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Glyphicon, {
    "aria-hidden": "true",
    className: clsx('text-size-400 margin-right-2', {
      'text-success': isModifySettingsIcon
    }),
    glyph: "success"
  }), /*#__PURE__*/_jsx(Text, {
    color: isModifySettingsIcon ? 'success' : undefined
  }, void 0, "Email Sent")), !oneClickEmailSent && (_Fragment || (_Fragment = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Glyphicon, {
    "aria-hidden": "true",
    className: "text-size-400 margin-right-2",
    glyph: "electric"
  }), "Send Email to Dealer"))))), isModifySettingsIcon && !hideModifySettings && /*#__PURE__*/_jsx(Button, {
    "aria-label": "Edit Your One-Click Email Settings",
    bsStyle: "default",
    bsSize: "small",
    onClick: handleEditSettings
  }, void 0, _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "edit",
    "aria-hidden": "true",
    className: "text-size-400"
  }))), !isModifySettingsIcon && !hideModifySettings && /*#__PURE__*/_jsx(Button, {
    bsStyle: "text",
    className: "display-block margin-top-3 text-center",
    onClick: handleEditSettings
  }, void 0, "Modify Settings"));
}
export default OneClickButton;